import { css } from 'styled-components';

export const DEFAULT_FOCUS_COLOR = '#005fcc';

export const getFocusStyles = (focusColor: string = DEFAULT_FOCUS_COLOR) => css`
  outline: 2px solid ${focusColor} !important;
  outline-offset: 2px;
  box-shadow: 0 0 0 2px #fff;
`;

export const focusVisibleMixin = (focusColor?: string) => css`
  &:focus-visible {
    ${getFocusStyles(focusColor)}
  }
`;
